import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import Img from 'react-cool-img';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import logo from '../../../assets/logo_farmRio.svg';
import Button from '../../Button';
import MenuDrawer from '../../ModalCollection/MenuDrawer';
import { events } from '../../../consts';
import { useEventDispatcher } from '../../../hooks';

const NavTab = ({ label, active, enabled, onClick, fontSize }) => (
  <Typography
    onClick={() => enabled && onClick()}
    style={{
      fontSize,
      height: 26,
      borderBottom: active && '2px solid #000',
      fontWeight: active && 'bold',
      cursor: enabled && 'pointer',
      color: enabled ? '#000' : '#d3d3d3',
    }}
  >
    {label}
  </Typography>
);

export default function CartNavbar({
  isMobile,
  profile,
  seasonName,
  nav,
  setNav,
  orderSelected,
  loadingOrder,
  onNext,
  onClose,
  show,
  setShow,
}) {
  const dispatchEvent = useEventDispatcher();
  const canEdit = !orderSelected || orderSelected.status === 'Notes';
  const tabFontSize = isMobile ? 12 : 14;

  const tabs = (
    <>
      <NavTab
        label="Shipping & Billing"
        active={nav === 'ship'}
        enabled={canEdit}
        onClick={() => setNav('ship')}
        fontSize={tabFontSize}
      />
      <NavTab
        label="Place Order"
        active={nav === 'place'}
        enabled={canEdit}
        onClick={() => setNav('place')}
        fontSize={tabFontSize}
      />
      <NavTab
        label="Review Order"
        active={nav === 'review'}
        enabled={isMobile ? canEdit : true}
        onClick={() => setNav('review')}
        fontSize={tabFontSize}
      />
    </>
  );

  return (
    <>
      <Grid container justifyContent="space-between">
        <MenuDrawer />
        <Img
          src={logo}
          style={{ width: isMobile ? 150 : 200, padding: '10px 0px 20px' }}
          alt="logoFarm"
        />
        <Grid style={{ width: 48 }} />
      </Grid>
      <Grid
        container
        justifyContent="center"
        style={{ margin: isMobile ? '-8px 0px 10px' : '-8px 0px 30px' }}
      >
        <Grid>
          <Typography
            align="center"
            style={{
              fontSize: isMobile ? 16 : 27,
              letterSpacing: '0.1em',
              fontFamily: 'Montserrat',
            }}
          >
            {profile?.name &&
              `${profile?.name?.toUpperCase()?.split(' ')[0]}'S `}
            <Typography
              display="inline"
              style={{
                fontWeight: 'bold',
                fontSize: isMobile ? 16 : 27,
                letterSpacing: '0.1em',
                fontFamily: 'Montserrat',
              }}
            >
              {seasonName}
            </Typography>{' '}
            ORDER
          </Typography>
        </Grid>
      </Grid>
      {nav !== 'finish' &&
        (isMobile ? (
          <>
            <Grid
              container
              justifyContent="space-between"
              style={{ padding: '0 5%' }}
            >
              {tabs}
            </Grid>
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              style={{
                padding: '0 5%',
                position: 'fixed',
                bottom: 0,
                zIndex: 100,
                background: '#fff',
                height: 50,
              }}
            >
              <Grid>
                <Grid container alignItems="center" onClick={onClose}>
                  <ArrowBackIcon
                    style={{ fontSize: 12, position: 'relative', top: 2 }}
                  />
                  <Typography
                    display="inline"
                    style={{ fontSize: 12, cursor: 'pointer', marginLeft: 5 }}
                  >
                    {' '}
                    Collection
                  </Typography>
                </Grid>
              </Grid>
              {(nav === 'review' || nav === 'place') && (
                <Grid>
                  <Typography
                    onClick={() => setShow(!show)}
                    style={{ fontSize: 12 }}
                  >
                    {nav === 'review' ? 'Account Info' : 'Order Summary'}
                  </Typography>
                </Grid>
              )}
              <Grid>
                <Button
                  width={120}
                  height={25}
                  textColor="#fff"
                  color={canEdit ? '#000' : '#d3d3d3'}
                  onClick={() => canEdit && onNext()}
                  fontSize={10}
                  loading={loadingOrder}
                  text={nav === 'review' ? 'Submit Order' : 'Next'}
                />
              </Grid>
            </Grid>
          </>
        ) : (
          <Grid container justifyContent="space-between">
            <Typography
              display="inline"
              style={{ fontSize: 14, cursor: 'pointer' }}
              onClick={onClose}
            >
              <ArrowBackIcon
                style={{ fontSize: 14, position: 'relative', top: 2 }}
              />{' '}
              Back to {orderSelected ? 'order history' : 'Collection'}
            </Typography>
            {tabs}
            <Grid>
              <Button
                width={148}
                height={40}
                textColor="#fff"
                color={canEdit ? '#000' : '#d3d3d3'}
                onClick={() => {
                  if (!canEdit) return;
                  onNext();
                  dispatchEvent(
                    nav === 'review' ? events.submitOrder : events.next
                  );
                }}
                loading={loadingOrder}
                text={nav === 'review' ? 'Submit Order' : 'Next'}
                disabled={!canEdit}
              />
            </Grid>
          </Grid>
        ))}
    </>
  );
}
